import React from "react";

export default function Logo({ size = "md" }) {
  const sizes = {
    sm: { mql: "text-2xl", group: "text-[8px]", pad: "px-3 py-1.5" },
    md: { mql: "text-3xl", group: "text-[10px]", pad: "px-4 py-2" },
    lg: { mql: "text-5xl", group: "text-sm", pad: "px-6 py-3" },
  };
  const s = sizes[size] || sizes.md;
  return (
    <div data-testid="mql-logo" className={`bg-white ${s.pad} inline-flex flex-col items-center justify-center rounded-sm leading-none select-none`}>
      <span className={`font-logo ${s.mql} text-[#0052FF] leading-none`}>Mql</span>
      <span className={`${s.group} font-bold tracking-[0.3em] text-black leading-none mt-0.5`}>GROUP</span>
    </div>
  );
}
